type PagePathModel = {
    /** 活动key, 例如 hz_news_year_2024 */
    activity: string

    /** 活动名称, 例如 新春纳福 2024 */
    activityName: string

    /** 页面key, 例如 main_page */
    page?: string

    /** 页面名称, 例如 首页 */
    pageName?: string
}

const RegisterPagePathMap: { pathname: string | RegExp; params: PagePathModel }[] = []

/**
 *
 * 为了实现方便埋点, 避免每次都需要传递 activity, activityName
 *
 * @description 注册页面模块
 * @param {string|RegExp} pathname - 参考 {@link window.location.pathname} '/temp/cicaf/20th/main' 或者为 正则表达式
 * @param {PagePathModel} params - 注册信息
 */
export function registerPathname(pathname: string | RegExp, params: PagePathModel) {
    RegisterPagePathMap.push({ pathname, params })
}

/**
 *
 * @description 获取页面注册信息
 * @param {string} pathname - 参考 {@link window.location.pathname}
 */
export function getRegisterInfoByPathname(pathname: string) {
    const isRegExp = (v: unknown): v is RegExp => {
        return Object.prototype.toString.call(v) === '[object RegExp]'
    }

    return RegisterPagePathMap.find((pagePath) => {
        /**
         *
         * 支持正则表达式
         */
        if (isRegExp(pagePath.pathname)) {
            return pagePath.pathname.test(pathname)
        }

        /**
         *
         * 支持路径 ** 匹配任意路径符
         */
        const registerPathname = pagePath.pathname.split('/')
        const currrentPathname = pathname.split('/')

        if (registerPathname.length !== currrentPathname.length) {
            return false
        }

        return registerPathname.every((pathname, index) => {
            if (pathname === '**') {
                return true
            }

            return pathname === currrentPathname[index]
        })
    })
}
